
<div class="login-page">

  <section class="hero">
    <div class="hero-brand">
      Cuida<span>Zap</span>
    </div>

    <div class="hero-copy">
      <span class="eyebrow">SEGURANÇA</span>
      <h1>Seu primeiro acesso.</h1>
      <p>
        Cadastre sua senha para proteger sua conta
        e começar a utilizar o CuidaZap.
      </p>
    </div>

    <div class="hero-bottom">
      CuidaZap • Backoffice
    </div>
  </section>

  <section class="form-side">
    <div class="login-card">

      <div class="welcome">PRIMEIRO ACESSO</div>

      <!-- ETAPA 1: E-MAIL -->
      <ng-container *ngIf="etapa === 'email'">

        <h2>Vamos começar?</h2>

        <p class="subtitle">
          Informe o e-mail cadastrado para continuar.
        </p>

        <form [formGroup]="formEmail" (ngSubmit)="continuar()">

          <div class="form-group">
            <label for="email">E-mail cadastrado</label>

            <input
              id="email"
              type="email"
              class="form-control"
              formControlName="email"
              autocomplete="email"
              placeholder="seu@email.com"
            />
          </div>

          <button
            type="submit"
            class="btn btn-primary submit"
            [disabled]="formEmail.invalid || loading"
          >
            Continuar →
          </button>
        </form>
      </ng-container>

      <!-- ETAPA 2: SENHAS -->
      <ng-container *ngIf="etapa === 'senha'">

        <h2>Crie sua nova senha</h2>

        <p class="subtitle">
          Conta: <strong>{{ email }}</strong>
        </p>

        <form [formGroup]="form" (ngSubmit)="salvar()">


          <div class="form-group">
            <label for="novaSenha">Nova senha</label>

            <input
              id="novaSenha"
              class="form-control"
              [type]="mostrarNovaSenha ? 'text' : 'password'"
              formControlName="novaSenha"
              autocomplete="new-password"
              placeholder="Mínimo de 8 caracteres"
            />

            <button
              type="button"
              class="password-toggle"
              (click)="mostrarNovaSenha = !mostrarNovaSenha"
            >
              {{ mostrarNovaSenha ? 'Ocultar' : 'Mostrar' }}
            </button>

            <small
              *ngIf="
                form.controls.novaSenha.touched &&
                form.controls.novaSenha.hasError('minlength')
              "
              class="error-message"
            >
              A senha deve ter pelo menos 8 caracteres.
            </small>
          </div>

          <div class="form-group">
            <label for="confirmacao">Confirme a nova senha</label>

            <input
              id="confirmacao"
              class="form-control"
              [type]="mostrarConfirmacao ? 'text' : 'password'"
              formControlName="confirmacao"
              autocomplete="new-password"
              placeholder="Repita a nova senha"
            />

            <button
              type="button"
              class="password-toggle"
              (click)="mostrarConfirmacao = !mostrarConfirmacao"
            >
              {{ mostrarConfirmacao ? 'Ocultar' : 'Mostrar' }}
            </button>
          </div>

          <p *ngIf="erro" class="error-message">
            {{ erro }}
          </p>

          <button
            type="submit"
            class="btn btn-primary submit"
            [disabled]="form.invalid || loading"
          >
            {{ loading ? 'Salvando...' : 'Cadastrar nova senha' }}
          </button>

          <button
            type="button"
            class="btn btn-outline submit"
            (click)="voltar()"
            [disabled]="loading"
          >
            Voltar
          </button>

        </form>
      </ng-container>

      <div class="help">
        <a routerLink="/login">← Voltar para o login</a>
      </div>

    </div>
  </section>
</div>
